import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ParamService} from './../../shared/services/param.service';
import {FreshpassService} from "./freshpass.service";

@Injectable({
    providedIn: 'root'
})
export class TokenUserInfo implements Resolve<any> {
    banner: any;
    url: string;
    Options: {} = {};

    constructor(private http: HttpClient, private paramService: ParamService, private freshpassService: FreshpassService) {
        this.banner = this.paramService.banner;
        if (window.location.href.indexOf('local') > 0) {
            // Using Unified Banners Call, if not unified, remove /unified/ from the url path
            this.url = this.freshpassService.getApplicationDomainURL() + '/bin/safeway/unified/userinfo?banner=' + this.banner + '&rand=' + Math.random();
            console.log('TokenUserInfo ->', this.url);
            this.Options['withCredentials'] = true;
        } else {
            // Using Unified Banners Call, if not unified, remove /unified/ from the url path
            this.url = '/bin/safeway/unified/userinfo?banner=' + this.banner;
        }
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Observable<never> {
        return this.http.get(this.url, this.Options);
    }
}
